// Browser equivalent of android/.../util/DeviceInfo.kt. Best-effort — the web
// platform deliberately exposes far less hardware info than Android, so model
// resolves to the browser engine and we leave mac_address empty.
//
// Values are computed once at module load (UA never changes mid-session) and
// re-exported as a single frozen object that deviceApi consumes verbatim.

function detectOs(): string {
  const ua = navigator.userAgent
  // Order matters — UA strings contain multiple matches (e.g. "Mac OS X" on iPad)
  const macMatch     = ua.match(/Mac OS X ([\d_]+)/)
  const androidMatch = ua.match(/Android ([\d.]+)/)
  if (/Windows NT 10\.0; .*Win64/.test(ua) && /Edg\/|Chrome\//.test(ua) && /; rv:|; arm/.test(ua) === false) {
    // Windows 11 reports as NT 10.0; the only reliable disambiguator is the
    // Sec-CH-UA-Platform-Version header, which Vite dev doesn't surface.
    // Fall back to a generic "Windows" — close enough for the dashboard chip.
  }
  if (/Windows NT 10\.0/.test(ua)) return 'Windows 10/11'
  if (/Windows NT 6\.3/.test(ua))  return 'Windows 8.1'
  if (/Windows NT 6\.1/.test(ua))  return 'Windows 7'
  if (/Windows/.test(ua))          return 'Windows'
  if (macMatch)                    return `macOS ${macMatch[1].replace(/_/g, '.')}`
  if (androidMatch)                return `Android ${androidMatch[1]}`
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS'
  if (/CrOS/.test(ua))             return 'ChromeOS'
  if (/Linux/.test(ua))            return 'Linux'
  return 'Web'
}

function detectBrowser(): string {
  const ua = navigator.userAgent
  // Edge / Opera identify themselves *after* Chrome in the UA, so check first.
  const edge   = ua.match(/Edg\/([\d.]+)/)
  const opera  = ua.match(/OPR\/([\d.]+)/)
  const chrome = ua.match(/Chrome\/([\d.]+)/)
  const firefox= ua.match(/Firefox\/([\d.]+)/)
  const safari = ua.match(/Version\/([\d.]+).*Safari/)
  if (edge)    return `Edge ${edge[1].split('.')[0]}`
  if (opera)   return `Opera ${opera[1].split('.')[0]}`
  if (chrome)  return `Chrome ${chrome[1].split('.')[0]}`
  if (firefox) return `Firefox ${firefox[1].split('.')[0]}`
  if (safari)  return `Safari ${safari[1].split('.')[0]}`
  return 'Web Browser'
}

const browser   = detectBrowser()
const osVersion = detectOs()

// Default friendly name shown in the dashboard until the operator renames it.
// Mirrors how Android registers as "Pixel 8" or similar — here we use the
// browser + OS combo since browsers don't expose hardware model.
const name = `WebTV (${browser} · ${osVersion})`

export const deviceInfo = Object.freeze({
  name,
  model:       browser,
  osVersion,
  appVersion:  __APP_VERSION__,
  deviceKind:  'web' as const,
})
